import dayjs from "dayjs";
import qs from "qs";

class ConvertUtil {
    /**
     * 충전기 ID에서 접미사를 추출한다.
     * "0123456789123-02" → "02"
     * "02" → "02" (이미 접미사인 경우 그대로 반환)
     */
    public static extractChargerId(fullChargerId: string): string {
        const parts = fullChargerId.split("-");
        return parts[parts.length - 1];
    }

    /**
     * date 형식의 문자열을 Date 로 변환
     * @param date
     */
    public static readonly toDate = (date: string): Date => {
        return dayjs(date).toDate();
    };

    public static queryStringify(query?: Record<string, any> | null, includeQuestion = true): string {
        if (!query) {
            return "";
        }

        if (Object.keys(query).length === 0) {
            return "";
        }

        return (includeQuestion ? "?" : "") + qs.stringify(query, { arrayFormat: "repeat", allowDots: true });
    }
}

export default ConvertUtil;
